const appKey = process.env.GATSBY_APP
if (!appKey) {
  throw new Error("appKey 不能为空")
}

const title = "2024机核年度报告"
const desc = "你的年度报告已生成，快来看看吧！"

const cdnUrl = "https://site.gcores.com"

module.exports = {
  appKey,
  cdnUrl,
  pageUrl: `${cdnUrl}/${appKey}/`,
  appInfo: {
    name: title,
    description: desc,
    shareTitle: title,
    shareDescription: desc,
  },
  pageDelay: 0,
}
